'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  flex-direction: row;\n  padding: 100px;\n\n  > *:not(:last-child) {\n    margin: 0 30px 0 0;\n  }\n'], ['\n  flex-direction: row;\n  padding: 100px;\n\n  > *:not(:last-child) {\n    margin: 0 30px 0 0;\n  }\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  align-items: center;\n  background: ', ';\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  padding: 60px 30px;\n  position: relative;\n  width: 100%;\n\n  > * {\n    max-width: 300px;\n\n    &:not(:last-child) {\n      margin: 0 0 30px 0;\n    }\n  }\n\n  @media (min-width: ', ') {\n    width: ', ';\n    ', '\n  }\n'], ['\n  align-items: center;\n  background: ', ';\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  padding: 60px 30px;\n  position: relative;\n  width: 100%;\n\n  > * {\n    max-width: 300px;\n\n    &:not(:last-child) {\n      margin: 0 0 30px 0;\n    }\n  }\n\n  @media (min-width: ', ') {\n    width: ', ';\n    ', '\n  }\n']);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _config = require('../../../config.js');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var HorizontalStyles = (0, _styledComponents.css)(_templateObject);

var Wrapper = _styledComponents2.default.div(_templateObject2, _config.colors.darkBlue, _config.breakpoints.l, function (props) {
  return props.$vertical ? '350px' : '100%';
}, function (props) {
  return !props.$vertical && HorizontalStyles;
});

Wrapper.displayName = 'Wrapper';

exports.default = Wrapper;